import styled from 'styled-components';

const FontSize15NavySpan = styled.span`
  color: #0658a9;
  font-size: 15px;
  letter-spacing: -1.1px;
`;

export default FontSize15NavySpan;
